import axios from 'axios';

const baseURL =
  import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

const api = axios.create({
  baseURL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  config => {
    const jwtToken = localStorage.getItem('jwtToken');

    if (jwtToken) {
      try {
        config.headers.Authorization = `Bearer ${jwtToken}`;
      } catch (error) {
        console.error('Error parsing rexiUser from localStorage:', error);
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const requestUrl = error.config?.url || error.request?.responseURL || '';
    const isAnonymousAuthEndpoint =
      requestUrl.includes('/auth/login') ||
      requestUrl.includes('/auth/forgot-password') ||
      requestUrl.includes('/auth/reset-password');

    if (error.response?.status === 401 && !isAnonymousAuthEndpoint) {
      localStorage.removeItem('jwtToken');
      window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
